import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Terms = () => {
  return (
    <div className="min-h-screen bg-[#050505]">
      <Navbar />
      
      <section className="pt-32 pb-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h1 className="text-4xl sm:text-5xl font-black font-heading text-white mb-8">
            Terms & Conditions
          </h1>
          
          <div className="glass-heavy rounded-2xl p-8 space-y-6 text-zinc-400">
            <div>
              <h2 className="text-2xl font-bold text-white mb-3">1. Introduction</h2>
              <p className="leading-relaxed">
                Welcome to AYRONN Funding. By accessing our services, you agree to be bound by these terms and conditions.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">2. Trading Rules</h2>
              <p className="leading-relaxed mb-3">
                All traders must adhere to the following rules:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Do not exceed the maximum drawdown limit</li>
                <li>Meet the profit target to pass the challenge</li>
                <li>No use of prohibited trading strategies</li>
                <li>All trades must be closed during news events if specified</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">3. Payouts</h2>
              <p className="leading-relaxed">
                Traders are eligible for payouts after passing the challenge and meeting all requirements. Payouts are processed bi-weekly.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">4. Account Termination</h2>
              <p className="leading-relaxed">
                We reserve the right to terminate accounts that violate our trading rules or terms of service.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">5. Liability</h2>
              <p className="leading-relaxed">
                AYRONN Funding is not liable for any trading losses. All trading involves risk and traders should only trade with capital they can afford to lose.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">6. Changes to Terms</h2>
              <p className="leading-relaxed">
                We reserve the right to modify these terms at any time. Continued use of our services constitutes acceptance of modified terms.
              </p>
            </div>

            <div className="rounded-xl border border-brand-gold/25 bg-brand-gold/[0.04] p-5">
              <h2 className="text-2xl font-bold text-brand-gold mb-3" data-testid="terms-marketing-clause">7. Marketing &amp; Demonstrational Content</h2>
              <p className="leading-relaxed">
                All data, statistics, images and interactive elements displayed on this website — including but not limited to
                <span className="text-white font-semibold"> payout proofs, screenshots, trader testimonials, leaderboards, live payout notifications, popup counters, earnings calculators, and displayed statistics </span>
                — are presented for
                <span className="text-white font-semibold"> marketing, illustrative and demonstrational purposes only</span>.
                Such content may be edited, sampled, anonymised or generated for presentation. Individual results and payouts vary and are not guaranteed. Nothing on this website should be construed as a representation of your own potential income, performance, or trading outcomes. By using this website you acknowledge and accept that all displayed figures are for demonstration only.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Terms;